import { Position } from '../types/simulation';

/**
 * Calculate Euclidean distance between two 3D points
 */
export function calculateDistance(p1: Position, p2: Position): number {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const dz = p2.z - p1.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

/**
 * Validate position values (check for NaN, Infinity)
 */
export function validatePosition(position: number[]): number[] {
  if (position.length !== 3) {
    throw new Error('Position must have exactly 3 values [x, y, z]');
  }

  return position.map((val) => {
    if (isNaN(val) || !isFinite(val)) {
      return 0;
    }
    return val;
  });
}

/**
 * Convert a string to a consistent color (for entity colors)
 */
export function stringToColor(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash & 0x00ffffff;
}

/**
 * Convert a string to a hex color string
 */
export function stringToHexColor(str: string): string {
  const color = stringToColor(str);
  return '#' + color.toString(16).padStart(6, '0');
}

/**
 * Format a number to a fixed number of decimal places
 */
export function formatNumber(num: number, decimals: number = 2): string {
  return num.toFixed(decimals);
}

/**
 * Clamp a value between min and max
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
